module.exports = __webpack_public_path__ + "img/result-h5-header.87fc4432.png";